import { ReducerAction, ReducerHandler } from '../../Types';

import { SET_MESSAGESOURCE } from '../Actions/messageSourceActions';
const initialState = {
    isOpen: false,
    messageIdentifier: '',
    content: [
        {
            title: '',
            description: '',
            url: '',
        },
    ],
};

const messageSourceReducerMap: Record<string, ReducerHandler<any>> = {
    [SET_MESSAGESOURCE]: (state, action) => ({ ...state, ...action.payload }),
};

function messageSourceReducer(state = initialState, action: ReducerAction): any {
    const handler = messageSourceReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default messageSourceReducer;
